import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { PerfilesService } from '@services/perfiles/perfiles.service';
import { Perfil } from '@interfaces/interface-bakend/seguridad/acl/perfil.interface';
import { coincideFuzzy } from '@shared/utils/fuzzy-search.util';

@Component({
    selector: 'app-roles-administracion',
    templateUrl: './roles-administracion.component.html',
    styleUrls: ['./roles-administracion.component.scss'],
})
export class RolesAdministracionComponent implements OnInit {

    @ViewChild(MatSort) set matSort(ms: MatSort) {
        if (ms) { this.dataSource.sort = ms; }
    }
    @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
        if (mp) { this.dataSource.paginator = mp; }
    }

    displayedColumns: string[] = ['key', 'descripcion', 'acciones'];
    dataSource: MatTableDataSource<Perfil> = new MatTableDataSource();

    flagLoaded: boolean = false;
    termino: string = '';

    constructor(
        private router: Router,
        private perfilesService: PerfilesService,
    ) {
        this.dataSource.filterPredicate = (data, filter) => {
            const texto = `${data.key} ${data.descripcion}`;
            return coincideFuzzy(texto, filter);
        };
    }

    async ngOnInit(): Promise<void> {
        await this.cargarPerfiles();
    }

    private async cargarPerfiles(): Promise<void> {
        const resp = await this.perfilesService.findAllPerfiles();
        console.log('[Roles][GET] respuesta cruda:', resp);
        const data = resp?.response ?? resp?.data ?? resp?.docs ?? resp?.results ?? resp;
        this.dataSource.data = Array.isArray(data) ? data : [];
        this.flagLoaded = true;
    }

    aplicarFiltro(termino: string): void {
        this.termino = termino;
        this.dataSource.filter = (termino || '').trim();
        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    editarPerfil(perfil: Perfil): void {
        this.perfilesService.setPerfilSeleccionado(perfil);
        this.router.navigateByUrl('/rol-edicion');
    }

    crearNuevo(): void {
        this.perfilesService.setPerfilSeleccionado(null);
        this.router.navigateByUrl('/rol-edicion');
    }

    volver(): void {
        this.router.navigateByUrl('/menu-seguridad');
    }
}
